import React, { Component } from "react";
import Layout from "../Layout";
import {
  Select,
  Button,
  BrandLogos,
  RegionsList,
  DealerTiles,
} from "~/js/partials";
import { processOtherBrands, groupDealerships } from "~/js/utils";

const brands = Object.values(window.brands_data);
const otherBrands = Object.values(window.otherBrands_data);
const processedOtherBrands = processOtherBrands(otherBrands);
let regions = [];

// Alphabetical sort again
brands.sort((a, b) => {
  let titleA = a.post_title.toUpperCase();
  let titleB = b.post_title.toUpperCase();
  return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
});

// Regions & dealership data for form population
let dealershipsGrouped = [];

class FormServiceEnquiry extends Component {
  componentDidMount() {
    regions = Object.values(this.props.regions)
// Regions & dealership data for form population
    dealershipsGrouped = groupDealerships(this.props.regions);

    dealershipsGrouped.forEach((region) => {
      if (region.label == "Wellington") {
        dealershipsGrouped.forEach((r) => {
          if (r.label == "Lower Hutt") {
            r.options = r.options.concat(region.options);
          }
        });
      }

      if (region.label == "Lower Hutt") {
        dealershipsGrouped.forEach((r) => {
          if (r.label == "Wellington") {
            r.options = region.options;
          }
        });
      }
    });
  }

  steps = [`Select Brand`, `Select Region`, `Select Dealership`];

  state = {
    brandID: null,
    regionID: null,
    dealerID: null,
    brandLabel: null,
    regionLabel: null,
    dealerLabel: null,
    dealer: null,
    currentStep: 0,
  };

  get isNoDealer() {
    return this.props.type === "book-service-no-dealer";
  }

  nextStep = () => {
    this.setState({ currentStep: this.state.currentStep + 1 }, function() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "EnquiryProcess",
        processType: this.props.type,
        processStep: `${this.state.currentStep}. ${
          this.steps[this.state.currentStep - 1]
        }`, // Step as of clicking continue
        processBrand: this.state.brandLabel,
        processRegion: this.state.regionLabel,
        processDealership: this.state.dealer
          ? this.state.dealer.post_title
          : null,
      });
    });
  };

  prevStep = () => {
    this.setState({ currentStep: this.state.currentStep - 1 });
  };

  goToBook = () => {
    if (this.state.dealer != null) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "EnquiryProcess",
        processType: this.props.type,
        processStep: `${this.state.currentStep + 1}. ${
          this.steps[this.state.currentStep]
        }`,
        processBrand: this.state.brandLabel,
        processRegion: this.state.regionLabel,
        processDealership: this.state.dealer
          ? this.state.dealer.post_title
          : null,
      });

      window.open(
        `${this.state.dealer.data["team-contacts"].service.link.url}`,
        "_blank"
      );
    }
  };

  renderForm = () => {
    let extraClass = window.dealerSlug
      ? `form-book-service-${window.dealerSlug}`
      : `form-book-service`;
    if (this.isNoDealer) {
      extraClass = `form-book-service`;
    }

    if (this.state.currentStep == 0) {
      return (
        <div className="popup-form__form">
          <div className="popup-form__group">
            <div className="popup-form__label popup-form__label--large popup-form__label--first">
              Select your vehicle brand
            </div>
            <div className="popup-form__row">
              <div className="popup-form__col">
                <BrandLogos
                  brands={brands}
                  selectedBrand={this.state.brandID}
                  handleTileClick={(brand) => {
                    this.setState(
                      { brandLabel: brand.post_title, brandID: brand.ID },
                      function() {
                        this.nextStep();
                      }
                    );
                  }}
                />
              </div>
            </div>

            <div className="popup-form__label">
              Is your vehicle brand not shown? No problem, select from the list
              below:
            </div>
            <div className="popup-form__row">
              <div className="popup-form__col">
                <Select
                  name={`other-brand`}
                  options={processedOtherBrands}
                  onChange={({ id, label }) => {
                    this.setState(
                      { brandLabel: label, brandID: id },
                      function() {
                        this.nextStep();
                      }
                    );
                  }}
                  onMenuOpen={() => {
                    // ISSUE: when user scrolls the popup all the way to the bottom of the popup, all scroll events within the popup is locked, this is possibly due to the use of the `body-scroll-lock` package
                    // HACK: Adjust the scrollTop of the overlay a bit to avoid scroll-locked
                    const popupFormOverlay = document.querySelector(
                      ".popup-form__overlay"
                    );
                    const {
                      scrollHeight,
                      offsetHeight,
                      scrollTop,
                    } = popupFormOverlay;
                    const maxScrollTop = scrollHeight - offsetHeight;
                    if (scrollTop === maxScrollTop)
                      popupFormOverlay.scrollTop -= 1;
                  }}
                  isDisabled={false}
                  modifiers={["form", "top-menu"]}
                />
              </div>
            </div>
          </div>

          {status && <div className={"popup-form__alert"}>{status}</div>}

          {/* <div className="popup-form__submit">
                        <Button 
                            extraClass={extraClass}
                            title={`Continue`} 
                            modifiers={['solid', 'medium']} 
                            chevron={true} 
                            type="submit" 
                            onClick={this.nextStep}
                            disabled={(this.state.brandID == null)}
                            loading={false}
                        />
                    </div> */}
        </div>
      );
    }

    if (this.state.currentStep == 1) {
      return (
        <div className="popup-form__form">
          <div className="popup-form__group">
            <div className="popup-form__label popup-form__label--large popup-form__label--first">
              Select region
            </div>
            <div className="popup-form__row">
              <div className="popup-form__col">
                <RegionsList
                  regions={regions}
                  selectedRegion={this.state.regionID}
                  handleTileClick={(region) => {
                    this.setState(
                      { regionLabel: region.name, regionID: region.term_id },
                      function() {
                        this.nextStep();
                      }
                    );
                  }}
                />
              </div>
            </div>
          </div>

          {status && <div className={"popup-form__alert"}>{status}</div>}

          <div className="popup-form__submit">
            <Button
              extraClass={extraClass}
              title={`Back`}
              modifiers={["outline", "medium", "reverse"]}
              reverseChevron={true}
              type="submit"
              onClick={this.prevStep}
              disabled={false}
              loading={false}
            />
            {/* <Button 
                            extraClass={extraClass}
                            title={`Continue`} 
                            modifiers={['solid', 'medium']} 
                            chevron={true} 
                            type="submit" 
                            onClick={this.nextStep}
                            disabled={(this.state.regionID == null)}
                            loading={false}
                        /> */}
          </div>
        </div>
      );
    }

    if (this.state.currentStep == 2) {
      return (
        <div className="popup-form__form">
          <div className="popup-form__group">
            <DealerTiles
              regions={regions}
              brands={brands}
              otherBrands={otherBrands}
              selectedBrand={this.state.brandID}
              selectedRegion={this.state.regionID}
              selectedDealer={this.state.dealerID}
              dealers={dealershipsGrouped}
              handleTileClick={(dealer) => {
                // if (dealer.ID !== this.state.dealerID) {
                this.setState(
                  { dealerID: dealer.ID, dealer: dealer },
                  function() {
                    this.goToBook();
                  }
                );
                // }
              }}
            />
          </div>

          {status && <div className={"popup-form__alert"}>{status}</div>}

          <div className="popup-form__submit">
            <Button
              extraClass={extraClass}
              title={`Back`}
              modifiers={["outline", "medium", "reverse"]}
              reverseChevron={true}
              type="submit"
              onClick={this.prevStep}
              disabled={false}
              loading={false}
            />
            {/* <Button 
                            extraClass={extraClass}
                            title={`Continue`} 
                            modifiers={['solid', 'medium']} 
                            chevron={true} 
                            type="submit" 
                            onClick={this.goToBook}
                            disabled={(this.state.dealerID == null)}
                            loading={false}
                        /> */}
          </div>
        </div>
      );
    }
  };

  render() {
    const { ...rest } = this.props;
    let title = `Book a service`;
    const text = `Follow these simple steps so we can help direct you to the right Armstrong's service centre. Once your selections are complete you will be guided to one of our local dealership booking pages.`;

    return (
      <Layout title={title} text={text} {...rest}>
        <div className="form-step-titles">
          {this.steps.map((step, index) => {
            let titleProps = {};
            titleProps.className = "form-step-titles__item";

            if (index == this.state.currentStep) {
              titleProps.className += " form-step-titles__item--current";
            }

            if (index > this.state.currentStep) {
              titleProps.className += " form-step-titles__item--disabled";
            }

            let clickFunc = null;
            if (index < this.state.currentStep) {
              clickFunc = () => {
                this.setState({ currentStep: index }, function() {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "EnquiryProcess",
                    processType: this.props.type,
                    processStep: `${this.state.currentStep}. ${
                      this.steps[this.state.currentStep - 1]
                    }`, // Step as of clicking continue
                    processBrand: this.state.brandLabel,
                    processRegion: this.state.regionLabel,
                    processDealership: this.state.dealer
                      ? this.state.dealer.post_title
                      : null,
                  });
                });
              };
            }

            return (
              <div {...titleProps} onClick={clickFunc}>
                <span>{index + 1}</span> {step}
              </div>
            );
          })}
        </div>
        <div className="form-hr"></div>
        {this.renderForm()}
      </Layout>
    );
  }
}

export default FormServiceEnquiry;
